import React from 'react';
import { RefreshCw } from 'lucide-react';
import cn from 'classnames';
import './pull-to-refresh-indicator.scss';

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  threshold: number;
  refreshing: boolean;
  shouldRefresh: boolean;
}

const PullToRefreshIndicator: React.FC<PullToRefreshIndicatorProps> = ({
  pullDistance,
  threshold,
  refreshing,
  shouldRefresh
}) => {
  const rotation = Math.min((pullDistance / threshold) * 360, 360);
  const opacity = Math.min(pullDistance / threshold, 1);

  if (pullDistance === 0 && !refreshing) {
    return null;
  }

  return (
    <div
      className={cn('pull-to-refresh-indicator', {
        refreshing,
        'should-refresh': shouldRefresh
      })}
      style={{ opacity }}
    >
      <div className='indicator-content'>
        <RefreshCw
          size={24}
          className={cn('refresh-icon', { spinning: refreshing })}
          style={{ transform: `rotate(${rotation}deg)` }}
        />
        <span className='refresh-text'>
          {refreshing
            ? 'Refreshing...'
            : shouldRefresh
              ? 'Release to refresh'
              : 'Pull to refresh'}
        </span>
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
